import { createSlice } from '@reduxjs/toolkit';

export const viewMode = createSlice({
  name: 'viewMode',
  initialState: {
    name: 'list',
  },
  reducers: {
    set: (state, action) => {
      state.name = action.payload;
    }
  },
})

export const setViewMode = viewMode.actions.set;
export default viewMode.reducer
